// extracted by mini-css-extract-plugin
module.exports = {"appointmentConfirmedText":"AppointmentConfirmed_appointmentConfirmedText__1NY2i"};